import styled from 'styled-components';
import { useAtom } from 'jotai';
import { FlexCenterBoth } from 'components/primitives/flex';
import BarsIcon from 'assets/scss/fortawesome/icons/svg/bars.svg';
import MapMarkerIcon from 'assets/scss/fortawesome/icons/svg/map-marker.svg';
import { getMinWidthQuery } from 'helpers/breakpoints';
import { isMapVisibleAtom } from './Filter/filterStore';
import { breakpoints } from './styleConstants';

export default function MobileMapToggleButton() {
  const [isMapVisible, toggleIsMapVisible] = useAtom(isMapVisibleAtom);
  return (
    <StyledButton onClick={() => toggleIsMapVisible()} isMapVisible={isMapVisible}>
      {isMapVisible ? (
        <>
          <BarsIcon fill="#fff" width={16} /> <div>LIST VIEW</div>
        </>
      ) : (
        <>
          <MapMarkerIcon fill="#fff" width={16} /> <div>MAP VIEW</div>
        </>
      )}
    </StyledButton>
  );
}

const StyledButton = styled(FlexCenterBoth)<{ isMapVisible: boolean }>`
  position: sticky;
  z-index: 10;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #0751c2;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.4);
  border-radius: 40px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 10px;
  gap: 6px;
  white-space: nowrap;
  padding: 0 18px;
  height: 46px;
  width: fit-content;
  cursor: pointer;

  ${({ isMapVisible }) => isMapVisible && 'position: fixed;'}

  ${getMinWidthQuery(breakpoints.MAP_CAN_SHOW)} {
    display: none;
  }
`;
